module.exports = __webpack_public_path__ + "static/img/mask_wx.8ed2b89.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/mask_wx.png
// module id = 90nq
// module chunks = 52